import { render, staticRenderFns } from "./inventory-card-list.vue?vue&type=template&id=674a59c5&"
import script from "./inventory-card-list.vue?vue&type=script&lang=js&"
export * from "./inventory-card-list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports